module.exports = __webpack_public_path__ + "static/media/fourthpdflogo.97f4cc60.png";